module.exports = "https://assets.niwcorp.com/_next/static/images/kaizenLogo-747bb418e425ca7e5149960715d611b0.jpg";